import React, {ReactNode, useMemo} from 'react';

import {Typography} from '@mui/material';

import {RaterStarIcon} from '@/app/icons';

import './styles';

interface RaterComponentProps {
  icon?: ReactNode;
  text: string;
  rating?: number;
}

export const RaterComponent: React.FC<RaterComponentProps> = ({
  icon = <RaterStarIcon />,
  text,
  rating = 0,
}) => {
  const formattedRating = useMemo(() => {
    return Number.isFinite(rating) ? rating.toFixed(1) : '0.0';
  }, [rating]);

  return (
    <div className="rater-container">
      <div className="rater-content">
        <span className="rater-icon-wrapper">{icon}</span>
        <Typography className="rater-text">
          <span className="rater-rating">{formattedRating}</span> {text}
        </Typography>
      </div>
    </div>
  );
};
